/* Global imports. */
import React from "react";
import { useStaticQuery, graphql, Script } from "gatsby";
import { useSiteMetadata } from "@src/hooks/useSiteMetaData"

import MegaMenu from "@components/MegaMenu";

function Header() {
  const data = useStaticQuery(graphql`
  query HeaderQuery {
    allKontentItemTemplateArticleList(filter: {elements: {title: {value: {ne: "Articles"}}, article_categories: {value: {elemMatch: {name: {ne: "News"}}}}}}) {
      nodes {
        elements {
          title {
            value
          }
          url_slug {
            value
          }
        }
      }
    }
    allKontentItemMailchimpNewsletterFooter {
      nodes {
        elements {
          html_markup {
            value
          }
        }
      }
    }
    kontentItemTemplateContributorList {
      elements {
        featured_contributors_heading {
          value
        }
        featured_contributors {
          value {
            ... on kontent_item_contributor_spotlight {
              id
              elements {
                link_url {
                  value
                }
                name {
                  value
                }
                image {
                  value {
                    description
                    height
                    name
                    size
                    type
                    url
                    width
                  }
                  name
                  type
                }
              }
            }
          }
        }
      }
    }
    kontentItemNavigationItem(system: {codename: {eq: "navigation__primary"}}) {
      id
      elements {
        internal_link {
          value {
            ... on kontent_item_template_genre {
              elements {
                url_slug {
                  value
                }
              }
            }
            ... on kontent_item_template__general {
              elements {
                url_slug {
                  value
                }
              }
            }
            ... on kontent_item_template__general_wide {
              elements {
                url_slug {
                  value
                }
              }
            }
            ... on kontent_item_template__events {
              elements {
                url_slug {
                  value
                }
              }
            }
          }
        }
        linked_item {
          value {
            ... on kontent_item_template__events {
              id
              system {
                type
              }
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
            ... on kontent_item_template_genre {
              id
              system {
                type
              }
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
            ... on kontent_item_template__contributor_list {
              id
              system {
                type
              }
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
            ... on kontent_item_template__article_list {
              id
              system {
                type
              }
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
            ... on kontent_item_template__general {
              id
              system {
                type
              }
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
            ... on kontent_item_template__general_wide {
              id
              system {
                type
              }
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
            ... on kontent_item_template__contributor_list {
              id
              system {
                type
              }
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
            ... on kontent_item_template__article_list {
              id
              system {
                type
              }
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
            ... on kontent_item_template__resources {
              id
              system {
                type
              }
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
            ... on kontent_item_navigation_item {
              id
              system {
                type
              }
              elements {
                title {
                  value
                }
                display_preferences {
                  value {
                    codename
                  }
                }
                internal_link {
                  value {
                    ... on kontent_item_template_genre {
                      elements {
                        url_slug {
                          value
                        }
                      }
                    }
                    ... on kontent_item_template__general {
                      elements {
                        url_slug {
                          value
                        }
                      }
                    }
                    ... on kontent_item_template__general_wide {
                      elements {
                        url_slug {
                          value
                        }
                      }
                    }
                    ... on kontent_item_template__contributor_list {
                      elements {
                        url_slug {
                          value
                        }
                      }
                    }
                    ... on kontent_item_template__article_list {
                      elements {
                        url_slug {
                          value
                        }
                      }
                    }
                  }
                }
                external_url {
                  value
                }
                linked_item {
                  value {
                    ... on kontent_item_navigation_item {
                      id
                      elements {
                        title {
                          value
                        }
                        display_preferences {
                          value {
                            codename
                          }
                        }
                        external_url {
                          value
                        }
                        internal_link {
                          value {
                            ... on kontent_item_template_genre {
                              elements {
                                url_slug {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template__general {
                              elements {
                                url_slug {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template__general_wide {
                              elements {
                                url_slug {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template__contributor_list {
                              elements {
                                url_slug {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template__article_list {
                              elements {
                                url_slug {
                                  value
                                }
                              }
                            }
                          }
                        }
                        linked_item {
                          value {
                            ... on kontent_item_navigation_item {
                              id
                              elements {
                                title {
                                  value
                                }
                                display_preferences {
                                  value {
                                    codename
                                  }
                                }
                                internal_link {
                                  value {
                                    ... on kontent_item_template_genre {
                                      elements {
                                        url_slug {
                                          value
                                        }
                                      }
                                    }
                                    ... on kontent_item_template__general {
                                      elements {
                                        url_slug {
                                          value
                                        }
                                      }
                                    }
                                    ... on kontent_item_template__general_wide {
                                      elements {
                                        url_slug {
                                          value
                                        }
                                      }
                                    }
                                    ... on kontent_item_template__contributor_list {
                                      elements {
                                        url_slug {
                                          value
                                        }
                                      }
                                    }
                                    ... on kontent_item_template__article_list {
                                      elements {
                                        url_slug {
                                          value
                                        }
                                      }
                                    }
                                  }
                                }
                                external_url {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template__general {
                              id
                              elements {
                                url_slug {
                                  value
                                }
                                short_title {
                                  value
                                }
                                title {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template__general_wide {
                              id
                              elements {
                                url_slug {
                                  value
                                }
                                short_title {
                                  value
                                }
                                title {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template_genre {
                              id
                              elements {
                                url_slug {
                                  value
                                }
                                title {
                                  value
                                }
                                short_title {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_imprint {
                              id
                              elements {
                                url_slug {
                                  value
                                }
                                title {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template__contributor_list {
                              id
                              elements {
                                url_slug {
                                  value
                                }
                                title {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template__article_list {
                              id
                              elements {
                                url_slug {
                                  value
                                }
                                title {
                                  value
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    ... on kontent_item_template__general {
                      id
                      elements {
                        url_slug {
                          value
                        }
                        title {
                          value
                        }
                        short_title {
                          value
                        }
                      }
                    }
                    ... on kontent_item_template__general_wide {
                      id
                      elements {
                        url_slug {
                          value
                        }
                        title {
                          value
                        }
                        short_title {
                          value
                        }
                      }
                    }
                    ... on kontent_item_template_genre {
                      id
                      elements {
                        url_slug {
                          value
                        }
                        title {
                          value
                        }
                        short_title {
                          value
                        }
                      }
                    }
                    ... on kontent_item_imprint {
                      id
                      elements {
                        url_slug {
                          value
                        }
                        title {
                          value
                        }
                      }
                    }
                    ... on kontent_item_template__contributor_list {
                      id
                      system {
                        type
                      }
                      elements {
                        url_slug {
                          value
                        }
                        title {
                          value
                        }
                        short_title {
                          value
                        }
                      }
                    }
                    ... on kontent_item_template__article_list {
                      id
                      system {
                        type
                      }
                      elements {
                        url_slug {
                          value
                        }
                        title {
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    dontmiss: kontentItemNavigationItem(system: {codename: {eq: "don_t_miss__primary_navigation_articles_"}}) {
      id
      elements {
        title {
          value
        }
        internal_link {
          value {
            ... on kontent_item_template_genre {
              elements {
                url_slug {
                  value
                }
              }
            }
            ... on kontent_item_template__general {
              elements {
                url_slug {
                  value
                }
              }
            }
            ... on kontent_item_template__general_wide {
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
          }
        }
        linked_item {
          value {
            ... on kontent_item_template_genre {
              id
              system {
                type
              }
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
            ... on kontent_item_template__contributor_list {
              id
              system {
                type
              }
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
            ... on kontent_item_template__article_list {
              id
              system {
                type
              }
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
            ... on kontent_item_template__general {
              id
              system {
                type
              }
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
            ... on kontent_item_template__general_wide {
              id
              system {
                type
              }
              elements {
                url_slug {
                  value
                }
                title {
                  value
                }
                short_title {
                  value
                }
              }
            }
            ... on kontent_item_navigation_item {
              id
              system {
                type
              }
              elements {
                title {
                  value
                }
                internal_link {
                  value {
                    ... on kontent_item_template_genre {
                      elements {
                        url_slug {
                          value
                        }
                      }
                    }
                    ... on kontent_item_template__general {
                      elements {
                        url_slug {
                          value
                        }
                      }
                    }
                    ... on kontent_item_template__general_wide {
                      elements {
                        url_slug {
                          value
                        }
                      }
                    }
                  }
                }
                external_url {
                  value
                }
                linked_item {
                  value {
                    ... on kontent_item_navigation_item {
                      id
                      elements {
                        title {
                          value
                        }
                        external_url {
                          value
                        }
                        internal_link {
                          value {
                            ... on kontent_item_template_genre {
                              elements {
                                url_slug {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template__general {
                              elements {
                                url_slug {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template__general_wide {
                              elements {
                                url_slug {
                                  value
                                }
                              }
                            }
                          }
                        }
                        linked_item {
                          value {
                            ... on kontent_item_navigation_item {
                              id
                              elements {
                                title {
                                  value
                                }
                                internal_link {
                                  value {
                                    ... on kontent_item_template_genre {
                                      elements {
                                        url_slug {
                                          value
                                        }
                                      }
                                    }
                                    ... on kontent_item_template__general {
                                      elements {
                                        url_slug {
                                          value
                                        }
                                      }
                                    }
                                    ... on kontent_item_template__general_wide {
                                      elements {
                                        url_slug {
                                          value
                                        }
                                      }
                                    }
                                  }
                                }
                                external_url {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template__general {
                              id
                              elements {
                                url_slug {
                                  value
                                }
                                short_title {
                                  value
                                }
                                title {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template__general_wide {
                              id
                              system {
                                type
                              }
                              elements {
                                url_slug {
                                  value
                                }
                                title {
                                  value
                                }
                                short_title {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template__general_wide {
                              id
                              system {
                                type
                              }
                              elements {
                                url_slug {
                                  value
                                }
                                title {
                                  value
                                }
                                short_title {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_template_genre {
                              id
                              elements {
                                url_slug {
                                  value
                                }
                                title {
                                  value
                                }
                                short_title {
                                  value
                                }
                              }
                            }
                            ... on kontent_item_imprint {
                              id
                              elements {
                                url_slug {
                                  value
                                }
                                title {
                                  value
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    ... on kontent_item_template__general {
                      id
                      elements {
                        url_slug {
                          value
                        }
                        title {
                          value
                        }
                        short_title {
                          value
                        }
                      }
                    }
                    ... on kontent_item_template__general_wide {
                      id
                      system {
                        type
                      }
                      elements {
                        url_slug {
                          value
                        }
                        title {
                          value
                        }
                        short_title {
                          value
                        }
                      }
                    }
                    ... on kontent_item_template_genre {
                      id
                      elements {
                        url_slug {
                          value
                        }
                        title {
                          value
                        }
                        short_title {
                          value
                        }
                      }
                    }
                    ... on kontent_item_imprint {
                      id
                      elements {
                        url_slug {
                          value
                        }
                        title {
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  `)

  const { social, useMailChimpFooterNewsletter } = useSiteMetadata()

  const mailchimp = useMailChimpFooterNewsletter ? data.allKontentItemMailchimpNewsletterFooter.nodes[0].elements.html_markup.value : null


  return (
  <>
  <Script
      id="fonts-com-script"
      key={`fonts-com-script`}
      dangerouslySetInnerHTML={{
        __html: `var MTIProjectId='53939781-1456-4fbc-8444-eb0f401d0378';
        (function() {
                var mtiTracking = document.createElement('script');
                mtiTracking.type='text/javascript';
                mtiTracking.async='true';
                mtiTracking.src='/js/mtiFontTrackingCode.js';
                (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild( mtiTracking );
          })();`,
      }}
    />
  <Script id="instagram-embed" key={`instagram-embed`} src="//www.instagram.com/embed.js" />
  <MegaMenu navItems={data.kontentItemNavigationItem.elements.linked_item.value} dontmiss={data.dontmiss} social={social} articleCategories={data.allKontentItemTemplateArticleList.nodes} featuredContributors={data.kontentItemTemplateContributorList.elements} mailchimp={mailchimp} />
  </>
  )
  
}

export default Header;
